import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usStates } from '../utils/usStates';

const StateSelect = ({
  value,
  onChange,
  country,
  variant = 'filled',
  sx = {},
  fullWidth = true,
  label = 'State',
  name = 'state',
  required = false,
  error = false,
  helperText = '',
  disabled = false
}) => {
  // State dropdown is only enabled for United States
  const isUSA = country === 'United States' || country === 'USA' || country === 'US';
  const isDisabled = disabled || !isUSA;
  
  // Find the state object from the value (which is the abbreviation)
  const selectedState = usStates.find(s => s.abbreviation === value) || null;
  
  // Clear state value if country is not USA
  React.useEffect(() => {
    if (!isUSA && value) {
      // Trigger onChange with empty value to clear the state
      const syntheticEvent = {
        target: {
          name: name,
          value: ''
        }
      };
      onChange(syntheticEvent);
    }
  }, [country, isUSA, value, onChange, name]);

  const handleChange = (_, newValue) => {
    // Create a synthetic event object similar to regular input onChange
    const syntheticEvent = {
      target: {
        name: name,
        value: newValue ? newValue.abbreviation : ''
      }
    };
    onChange(syntheticEvent);
  };

  return (
    <Autocomplete
      id={name}
      options={isUSA ? usStates : []}
      getOptionLabel={(option) => `${option.name} (${option.abbreviation})`}
      value={isUSA ? selectedState : null}
      onChange={handleChange}
      disabled={isDisabled}
      fullWidth={fullWidth}
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={isUSA ? label : `${label} (US only)`}
          variant={variant}
          required={required && isUSA}
          error={error}
          helperText={helperText && !isDisabled ? helperText : ''}
          name={name}
        />
      )}
      isOptionEqualToValue={(option, value) => option.abbreviation === value?.abbreviation}
      clearOnBlur
      selectOnFocus
      handleHomeEndKeys
      blurOnSelect
      noOptionsText={isUSA ? "No states found" : "Select United States as country first"}
    />
  );
};

export default StateSelect;